import React, { ReactElement } from 'react';
import { Redirect, useLocation } from 'react-router-dom';

export function PreOnboardingRedirectContainer(): ReactElement {
  const location = useLocation();
  const redirectPath = location.pathname.replace(
    '/pre-onboarding/',
    '/self-onboarding/',
  );
  return <Redirect to={redirectPath} />;
}
